/*
 *   File : ChartStatsCard.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React from "react";
import Icon from "../icons";

export default function ChartStatsCard(props) {
  return (
    <div className="row h-100 e-bg-floral-white e-py-20px px-3 row-gap-3 e-border-1px-blond rounded-4 flex-wrap">
      <div className="col-lg-3 col-md-2 px-0 col-1">
          <Icon icon={props.icon} color="black" size={40} />
      </div>
      <div className="col-9 ps-md-0 ps-3">
        <div className="row d-flex justify-content-between align-items-center">
          <h4 className="e-font-12 e-font-weight-500 text-uppercase e-primary-font-poppins line-height-20px truncate-second-line">
            {props.title}
          </h4>
        </div>
        <div className="row">
          <p className="fs-3 e-font-weight-700 e-primary-font-Inter py-0 m-0">
            {props.content}
          </p>
        </div>
      </div>
    </div>
  );
}
